import HttpClient from '@/repositories/clients/httpClient';

/**
 * Service to handle ORA Vision token generation and URL building.
 */
class OraVisionService {

  /**
   * Generate an ORA Vision JWT token via the backend proxy.
   *
   * @param {Object} payload - { userId, configurationId, readingId }
   * @returns {Promise<string>} The generated JWT token
   */
  async generateToken(payload = {}) {
    const response = await HttpClient.post('ora-token/generate', payload);
    return response?.data?.data?.token;
  }

  /**
   * Build the full ORA Vision URL with the JWT token.
   *
   * @param {string} token - The JWT token
   * @returns {string} The complete ORA Vision URL
   */
  buildUrl(token) {
    const baseUrl = window.env.VITE_ORA_VISION_URL || import.meta.env.VITE_ORA_VISION_URL || 'https://webservices.rmasa.com/oraconnecthub/oravision-fdv/';
    return `${baseUrl}?jwt=${token}`;
  }
}

export default new OraVisionService();


